export default "__VITE_ASSET__ee463534__"